module.exports = __webpack_public_path__ + "images/Monti_2510-1 RECADRER.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/babel/Monti_2510-1 RECADRER.jpg
// module id = 52
// module chunks = 0